import React, {useEffect, useState} from "react";
import {
    useReactTable, getCoreRowModel, getPaginationRowModel, getSortedRowModel, flexRender
} from "@tanstack/react-table";
import axios from "axios";
import "./../ReactTable/reacttable.css";
import './reacttable.css'
import {useSelector, useDispatch} from "react-redux";
import {LOGIN_LOADING, SHOULD_RELOAD_TABLE_DATA, SHOULD_RELOAD_TABLE_DATA_SUCCESS} from "../../../constants";

const ReactTableServerSide = ({
                                  fetchData,
                                  columns,
                                  colWidths,
                                  searchPlaceholder,
                                  initialSortState,
                                  showSpecialFilterButton,
                                  specialFilterOffText,
                                  specialFilterOnText,
                                  isSpecialFilter,
                                  setIsSpecialFilter,
                                  specialFilterHeadings,
                                  tableColumnShadeBeginsAt,
                                  tableColumnShadeEndsAt,
                                  secondHalfOfTableBgColor,
                                  externalSearchBy,
                                  externalSearchTerm,
                              }) => {

    const dispatch = useDispatch();
    const shouldReloadTableData = useSelector((state) => state.auth.shouldReloadTableData);

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({pageIndex: 0, pageSize: 20});
    const [sorting, setSorting] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [columnFilters, setColumnFilters] = useState([]);
    const [filters, setFilters] = useState({});
    const [searchBy, setSearchBy] = useState('');
    const [searchTerm, setSearchTerm] = useState('');


    const handleChangeFilters = (e, header) => {
        if (!e.target) return;
        const value = e.target.value;
        setFilters({[header.id]: value});
        header.column.setFilterValue(value);
        setColumnFilters((prev) => [
            {id: header.id, value: value}
        ]);
        handleClearButtons({
            activeId: value > '' ? header.id : '',
        });
    };

    const handleChangeSearchQuery = (value) => {
        const clearBtn = document.getElementById('clearButton');
        if (value) {
            clearBtn.style.display = "block";
        } else {
            clearBtn.style.display = "none";
        }
    };

    const handleClearButtons = ({activeId}) => {
        const tableheader = document.getElementById('tableheader');
        const allClearButtons = tableheader.getElementsByClassName("clear-button");

        for (let buttonElement of allClearButtons) {
            if (buttonElement.id === `clearButton-${activeId}`) {
                const clearBtn = document.getElementById(buttonElement.id);
                clearBtn.style.display = "block";

            } else {
                const clearBtn = document.getElementById(buttonElement.id);
                clearBtn.style.display = "none";
            }
        }

    };

    const toggleSpecialFilter = () => {
        // Switching filters changes the result set, so always restart from page 1
        setPagination((prev) => ({...prev, pageIndex: 0}));
        if (!isSpecialFilter) {
            setSearchTerm(true);
            setSearchBy('hasDuplicateErr');
        }
        if (isSpecialFilter) {
            setSearchTerm('');
            setSearchBy('');
        }
        setIsSpecialFilter(!isSpecialFilter);
    }

    const loadData = async (isMountedRef) => {

        setLoading(true);
        const sortBy = sorting.length ? sorting[0].id : "";
        const sortOrder = sorting.length && sorting[0].desc ? "desc" : "asc";

        const effectiveSearchBy = (externalSearchBy !== undefined && externalSearchBy !== null) ? externalSearchBy : searchBy;
        const effectiveSearchTerm = (externalSearchTerm !== undefined && externalSearchTerm !== null) ? externalSearchTerm : searchTerm;

        const {data, total} = await fetchData({
            currentPage: pagination.pageIndex + 1,
            limit: pagination.pageSize,
            sortBy,
            sortDirection: sortOrder,
            searchTerm: effectiveSearchTerm,
            searchBy: effectiveSearchBy,
        });

        // Only update state if component is still mounted
        if (isMountedRef && isMountedRef.current) {
            setData(data);
            setTotalRows(total);
            setLoading(false);
            dispatch({type: SHOULD_RELOAD_TABLE_DATA_SUCCESS});
        }
    };

    useEffect(() => {
        const isMounted = { current: true };
        loadData(isMounted);

        return () => {
            isMounted.current = false;
        };
    }, [pagination, sorting, searchTerm, searchBy, externalSearchBy, externalSearchTerm]);

    useEffect(() => {
        if (shouldReloadTableData === false) {
            return;
        }
        const isMounted = { current: true };
        loadData(isMounted);

        return () => {
            isMounted.current = false;
        };
    }, [shouldReloadTableData]);

    // const columns = [{accessorKey: "id", header: "ID"}, {accessorKey: "name", header: "Name"}, {
    //     accessorKey: "email",
    //     header: "Email"
    // }, {accessorKey: "phone", header: "Phone"},];

    const table = useReactTable({
        data,
        columns,
        pageCount: Math.ceil(totalRows / pagination.pageSize),
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        state: {pagination, sorting},
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    function clearSearch() {
        setSearchQuery('');
        handleChangeSearchQuery('');
    }

    const startSearch = (e) => {
        if (!e.target) return;
        const updateSearchBy = (columnFilters.length > 0 && columnFilters[0].id) || '';
        const updateSearchTerm = (columnFilters.length > 0 && columnFilters[0].value) || '';
        setSearchBy(updateSearchBy);
        setSearchTerm(updateSearchTerm);
    };

    function clearThisFilter({clearThisId}) {
        setFilters([]);
        setColumnFilters([]);
        const hideClearButton = document.getElementById(`clearButton-${clearThisId}`);
        hideClearButton.style.display = "none";
        setSearchTerm('');
        setSearchBy('');
    }

    const useColWidths = colWidths && colWidths.length && colWidths.length >= columns.length;

    return (
        <div>
            {<div style={{display: "flex"}}>
                {showSpecialFilterButton && <div
                    style={{display: "inline-block", marginLeft: "auto"}}
                    className={`sos-custom-btn-new-message ${isSpecialFilter ? "sos-custom-btn-css" : "sos-secondary-btn-css"} mb-1 w-25 float-right`}
                    onClick={() => toggleSpecialFilter()}
                >
                    {isSpecialFilter ? specialFilterOnText : specialFilterOffText}
                </div>}
            </div>}

            <div
                className="react-table table-font-size table-responsive"
            >
                <table
                    className="zui-table zui-table-rounded table-striped table-hover table-sm"
                    style={{tableLayout: (colWidths && colWidths.length === columns.length) ? "fixed" : "auto"}}
                >
                    <thead className="tableheader" id="tableheader">
                    {/* Top header row */}
                    {isSpecialFilter && <tr>

                        {specialFilterHeadings.map((header, index) => (
                            <th
                                key={index}
                                colSpan={header.colSpan > 1 ? header.colSpan : undefined} // omit colSpan if it's 1
                                style={{
                                    textAlign: header.label ? "center" : undefined,
                                    backgroundColor: index === 0 ? "#f1f1f1": secondHalfOfTableBgColor,
                                    fontWeight: header.label ? "bold" : undefined,
                                    border: "1px solid #ddd",
                                }}
                            >
                                {header.label}
                            </th>
                        ))}
                    </tr>}

                    {/* Main header row */}
                    <tr>
                        {table.getFlatHeaders().map((header, index) => {
                            const isShadedColumnsOfTable = showSpecialFilterButton && isSpecialFilter && index > tableColumnShadeBeginsAt && index < tableColumnShadeEndsAt;

                            return (
                                <th
                                    key={header.id}
                                    style={{
                                        backgroundColor: isShadedColumnsOfTable ? secondHalfOfTableBgColor : "#ffffff",
                                        cursor: "pointer",
                                        width: header.getSize(),
                                    }}
                                    onClick={() =>
                                        header.column.columnDef.enableSorting &&
                                        header.column.toggleSorting()
                                    }
                                >
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {header.column.getIsSorted() === "desc"
                                        ? " 🔽"
                                        : header.column.getIsSorted() === "asc"
                                            ? " 🔼"
                                            : ""}
                                </th>
                            );
                        })}
                    </tr>

                    <tr className="mb-5">
                        {table.getFlatHeaders().map((header, index) => {
                            const isShadedColumnsOfTable = showSpecialFilterButton && isSpecialFilter && index > tableColumnShadeBeginsAt && index < tableColumnShadeEndsAt;

                            return (
                                <th
                                    key={`filter-${header.id}`}
                                    style={{
                                        width: header.getSize(),
                                        backgroundColor: isShadedColumnsOfTable ? secondHalfOfTableBgColor : "#ffffff",
                                    }}
                                >
                                    {!isSpecialFilter && header.column.getCanFilter() ? (
                                        <div className="search-container">
                                            <input
                                                id={`searchInput-${header.id}`}
                                                type="text"
                                                className="form-control search-input"
                                                style={{
                                                    paddingRight: "1.5em",
                                                }}
                                                value={filters[header.id] || ""}
                                                onChange={(e) => handleChangeFilters(e, header)}
                                                onBlur={(e) => startSearch(e)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        startSearch(e);
                                                    }
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="clear-button"
                                                id={`clearButton-${header.id}`}
                                                onClick={(e) =>
                                                    clearThisFilter({ clearThisId: header.id })
                                                }
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ) : (
                                        <input type="text" disabled value="" style={{ display: "none" }} />
                                    )}
                                </th>
                            );
                        })}
                    </tr>

                    </thead>

                    <tbody className="react-table">
                    {loading ? (
                        <tr>
                            <td colSpan={columns.length} className="text-center">
                                <div className="spinner-border text-primary" role="status"></div>
                            </td>
                        </tr>
                    ) : (isSpecialFilter && totalRows === 0) ? (
                        <tr>
                            <td colSpan={columns.length} className="text-center">
                                No open duplicate errors.
                            </td>
                        </tr>
                    ) : (
                        table.getRowModel().rows.map((row, rowIndex) => (
                            <tr key={row.id} className="payer-table">
                                {row.getVisibleCells().map((cell, cellIndex) => {
                                    const isShadedColumnsOfTable = showSpecialFilterButton && isSpecialFilter && cellIndex > tableColumnShadeBeginsAt && cellIndex < tableColumnShadeEndsAt;

                                    return (
                                        <td
                                            key={cell.id}
                                            style={{
                                                width: cell.column.getSize(),
                                                backgroundColor: isShadedColumnsOfTable ? secondHalfOfTableBgColor : "#ffffff",
                                            }}
                                        >
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    )}
                    </tbody>

                </table>


                {/* Pagination Controls */}
                <div className="d-flex justify-content-between mb-2 mt-2">
                    <button className="sos-custom-btn sos-custom-btn-css sos-secondary-btn-padding"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}>
                        Previous
                    </button>
                    <span>
          Page {pagination.pageIndex + 1} of {table.getPageCount() || 1}
        </span>
                    <button
                        className="sos-custom-btn sos-custom-btn-css sos-secondary-btn-padding"
                        onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>

                        Next
                    </button>
                </div>
            </div>
        </div>);
};

export default ReactTableServerSide;
